export enum AnnouncementsRoutePathNames {
  ANNOUNCEMENTS = 'announcements',
  ANNOUNCEMENT_UPDATE = ':id',
  LIST = '',
}
